import styles from "../../styles/ThoughtOfTheDay/Thought.module.css";
import Thought from "../../Utils/Thought";

const ThoughtOfTheDay = () => {
  return (
    <div className={styles.thoughtContainer}>
      <div className={styles.thoughtInnerContainer}>
        <img className={styles.thoughtLeft} src="/left.svg" alt="left-icon" />
        <div className={styles.thoughtThought}>{Thought.thought}</div>
        <div className={styles.thoughtAuthor}>{Thought.author}</div>
        <img className={styles.thoughtRight} src="/right.svg" alt="right-icon" />
      </div>
    </div>
  );
};

export default ThoughtOfTheDay;
